export default __webpack_public_path__ + "static/media/Cloud3.6a405567.svg";